import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../_services/authentication.service';
import { MessageService } from '../_services/message.service';
import { LocationStrategy } from '@angular/common';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-verification',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.css']
})
export class VerificationComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private messageService: MessageService,
    private locationStrategy: LocationStrategy) {
    this.route.params.subscribe((params) => {
      const dataquerystring = params.username.toString().split(',').join('/').split('xMl393Jk').join('+');
      this.data = CryptoJS.AES.decrypt(dataquerystring, environment.encodeKey).toString(CryptoJS.enc.Utf8);
      this.username = this.data.split('|')[0];
      this.password = this.data.split('|')[1];
      this.idAplicacion = params.idAplicacion;
    });
    this.route.queryParams.subscribe(params => {
      this.filtroAdicional = params.filtroAdicional;
      this.redirectUrl = params.redirectUrl;
    });
  }

  @ViewChild('code2') mycode2: ElementRef;
  codeCognito = '';
  data = '';
  invalidCode = false;
  username = '';
  password = '';
  idAplicacion: string;
  filtroAdicional: string;
  redirectUrl: string;

  cod1 = '';
  cod2 = '';
  cod3 = '';
  cod4 = '';
  cod5 = '';
  cod6 = '';

  ngOnInit(): void {
    this.preventBackButton();

    (function($) {
      $(document).ready(function() {

        $('input.id-num-verificacion').keyup(function() {
          const largo = $(this).val();
          if (largo != '') {
            $(this).next().focus();
          }
        });

      });
    })(jQuery);

  }

  accountConfirm() {
    this.invalidCode = false;
    const message = `La cuenta con el correo electrónico <strong>${this.username}</strong> ha sido confirmada.`;
    this.authenticationService.confirmSignUp(this.username, this.codeCognito).subscribe(a => {
        this.messageService.sendMessage('Confirmación de cuenta', message);
        this.authenticationService.login(this.username, this.password, this.idAplicacion, this.filtroAdicional).subscribe(resp => {
          this.authenticationService.redirectUsuarioLogeado(resp, this.redirectUrl);
        });
    }, error => {
      switch (error.status){
        case 409:
            this.messageService.sendMessage('Error', error.error, 0, 'danger');
            break;
        default:
          this.messageService.sendErrorMessage();
      }
    });
  }

  resendCode() {
    const message = `Hemos reenviado un nuevo código de confirmación al correo <strong>${this.username}</strong>.`;
    this.authenticationService.resendCode(this.username).subscribe(o => {
        this.messageService.sendMessage('Creación de Usuario', message);
    }, error => {
      this.messageService.sendErrorMessage();
    });
  }

  preventBackButton() {
    history.pushState(null, null, location.href);
    this.locationStrategy.onPopState(() => {
      history.pushState(null, null, location.href);
    });
  }

  updateName() {
    this.codeCognito = this.cod1 + this.cod2 + this.cod3 + this.cod4 + this.cod5 + this.cod6;
  }
}
